export const SET_CART_ITEMS = 'SET_CART_ITEMS';
export const SET_CART_ITEM = 'SET_CART_ITEM';
export const ADD_CART_ITEM = 'ADD_CART_ITEM';
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';
export const CLEAR_CART_ITEM = 'CLEAR_CART_ITEM';
export const CLEAR_CART_ITEMS = 'CLEAR_CART_ITEMS';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const REMOVE_CART_ITEMS = 'REMOVE_CART_ITEMS';
